import { useEffect, useState } from 'react';
import { DEPLOYMENT_ENVIRONMENT, DeploymentEnvironment } from 'env/environments';
import { getIntegrationZHLOriginForDeploymentEnvironment } from 'src/components/ZillowNavbar/utils/getIntegrationZHLOriginForDeploymentEnvironment';
import { TOP_NAV_DATA } from '../data/production';
import { ZillowNavbarState } from '../data/types';

export const useZillowNavbarState = ({ env }: { env: DeploymentEnvironment }): ZillowNavbarState => {
    /**
     * Default to production values for best performance in production, and we can just
     * incur the bigger payload in lower environments.
     */
    const [zillowNavbarData, setZillowNavbarData] = useState<ZillowNavbarState>({
        ...TOP_NAV_DATA,
        zhlHost: getIntegrationZHLOriginForDeploymentEnvironment(DEPLOYMENT_ENVIRONMENT.PRODUCTION),
    });

    useEffect(() => {
        const asynchronouslyLoadTopNavData = async () => {
            const zhlHost = getIntegrationZHLOriginForDeploymentEnvironment(env);
            if (env === DEPLOYMENT_ENVIRONMENT.PRODUCTION) {
                return setZillowNavbarData({
                    ...TOP_NAV_DATA,

                    zhlHost,
                });
            }
            const { STAGING_TOP_NAV_DATA } = await import(
                /* webpackChunkName: "stagingZillowNavigationData" */
                '../data/staging'
            );
            setZillowNavbarData({
                ...STAGING_TOP_NAV_DATA,
                zhlHost,
            });
        };
        asynchronouslyLoadTopNavData();
    }, [env]);

    return zillowNavbarData;
};
